const IPV4_OCTET = "(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])";
const IPV4_REGEX = new RegExp(`^${IPV4_OCTET}(\\.${IPV4_OCTET}){3}$`);
const IPV6_REGEX =
  /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;

/** Accepts a bare IPv4/IPv6 address or a CIDR range (e.g. 203.0.113.10, 198.51.100.0/24, ::1/128) */
export const isValidIpOrCidr = (value: string): boolean => {
  const parts = value.split("/");
  if (parts.length > 2) return false;

  const [address, prefix] = parts;
  const isIpv4 = IPV4_REGEX.test(address);
  const isIpv6 = !isIpv4 && IPV6_REGEX.test(address);
  if (!isIpv4 && !isIpv6) return false;

  if (prefix === undefined) return true;
  if (!/^\d+$/.test(prefix)) return false;

  const prefixNum = Number(prefix);
  const maxPrefix = isIpv4 ? 32 : 128;
  return prefixNum >= 0 && prefixNum <= maxPrefix;
};
